import * as React from 'react';
import styled from 'styled-components';
import {LaerdalLoadingLogo} from '../assets';

import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import {COLORS, ComponentTextStyle} from '../styles';
import {ComponentMStyling} from '../styles/typography';

const LoadingMain = styled.main`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: ${props => COLORS.getColor('primary_20', props.theme)};
  height: 100%;
`;

const Header = styled.div`
  height: 64px;
  background-color: ${props => COLORS.getColor('white', props.theme)};
  border-bottom: 1px solid ${props => COLORS.getColor('neutral_200', props.theme)};
`;

const LogoAndMessage = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  bottom: 36px;
  left: 50%;
  transform: translate(-50%);
  align-items: center;

  span {
    margin-bottom: 40px;
    font-weight: normal;
    width: 320px;
    text-align: center;
    
    ${props => ComponentMStyling(ComponentTextStyle.Regular, COLORS.generateToken({componentType:'text',defaultVariant:'subtle'}, props.theme))}
  }
`;

const LoadingIndicatorContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export interface LoaderProps {
  optionalMessage?: string;
  includeHeader?: boolean;
}

const LoadingPage: React.FunctionComponent<LoaderProps> = ({ optionalMessage, includeHeader }: LoaderProps) => {
  return (
    <LoadingMain data-testid="TestLoadingMain">
      {includeHeader && <Header />}
      <LoadingIndicatorContainer>
        <LoadingIndicator />
      </LoadingIndicatorContainer>
      <LogoAndMessage data-testid="TestLoadingLogoAndMessage">
        {optionalMessage && <span>{optionalMessage}</span>}
        <LaerdalLoadingLogo />
      </LogoAndMessage>
    </LoadingMain>
  );
};

export default LoadingPage;
